<template>
  <div class="custom-container">
    <v-skeleton-loader
      v-if="loading"
      type="image@3"
    />
    <div
      v-for="(q, i) in questionnaires"
      v-else
      :key="`order-${i}`"
      class="custom-container"
      style="margin-bottom: 12px"
    >
      <div
        class="custom-primary-text"
        style="margin-bottom: 8px"
      >
        ({{ $t('course_report.question') }}{{ i+1 }}). {{ q.question }}
      </div>
      <div
        class="custom-container"
        style="line-height: 1.5; min-height: 6rem;"
      >
        {{ q.answer }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    questionnaires: {
      type: Array,
      required: true,
      default: () => [{question: '', answer: ''}]
    }
  },
}
</script>

<style scoped>
.custom-container {
  border: solid 1px;
  background-color: #fff;
  border-radius: 4px;
  padding: 16px;
  overflow: hidden;
}

.custom-primary-text {
  color: var(--v-primary-base) !important;
}
</style>
